<template>
  <v-container fluid class="pa-0 position-relative chat-container">
    <v-layout row wrap v-if="!creating">
      <v-flex xs12>
        <v-btn
          block
          depressed
          class="pointy-borders resolve-btn"
          :disabled="chat.channel_id === 14 || chat.chat_center_status_id === 7"
          :class="{ 'k-orange-linear': chat.chat_center_status_id !== 7, 'k-blue-linear': chat.chat_center_status_id === 7}"
          @click="solve()">
          <template v-if="chat.chat_center_status_id !== 7">
            Marcar como resuelto
          </template>
          <template v-else>
            El chat esta resuelto
          </template>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout column wrap>
          <v-flex class="chat-room-container" :class="{ 'email-editor-opened': showEmailEditor }">
            <vue-perfect-scrollbar ref="chatRoomScrollbar" @click.native.prevent="$emit('closeEmailEditor')" :style="css">
              <div class="chat-room px-3 py-3">
                <div v-if="chat.channel_id === 7" class="security-message mb-3">
                  <v-icon size="small">fas fa-lock</v-icon>
                  Los mensajes enviados a este chat están seguros con cifrado de extremo a extremo.
                </div>
                <template v-if="chat.chat_center_messages.length > 0">
                  <template v-for="(message, index) in messages">
                    <div
                      class="text-xs-center mb-3"
                      v-if="message && message.should_show_date"
                      :key="`chat-room-message-date-${index}`">
                      {{ message.date_to_show }}
                    </div>
                    <chat-center-message
                    :message="message"
                    :index="index"
                    :chat="chat"
                    :update-chat-scrollbar="updateChatScrollbar"
                    @scrollbarUpdated="updateChatScrollbar = false"
                    @changeChatCategory="changeChatCategory"
                    @updateChatCategory="updateChatCategory"
                    @activeAudio="activeAudio"
                    >
                    </chat-center-message>
                  </template>
                </template>
              </div>
            </vue-perfect-scrollbar>
          </v-flex>
          <slot>
          </slot>
        </v-layout>
      </v-flex>
    </v-layout>
    <solved-dialog v-if="showState" @mark-solved="markSolved"></solved-dialog>
    <!-- <edit-solve-dialog
      v-if="messageId !== '' && chatCategoryId !== ''"
      :show="show"
      :message-id="messageId"
      :chat-category-id="chatCategoryId"
      @close="show = false"
      @updateChatCategory="updateChatCategory">
    </edit-solve-dialog> -->
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import Vue from 'vue';
import moment, { utc } from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import SolvedDialog from '@/components/chat_center/SolvedDialog';
import chatCenterMixin from '@/mixins/chatCenterMixin';
import ChatCenterMessage from '@/components/chat_center_v2/ChatCenterMessage';;
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css'; // eslint-disable-line
// import EditSolveDialog from './EditSolveDialog';

Vue.use(Viewer);

export default {
  props: {
    creating: {
      type: Boolean,
      default: false,
    },
    chat: {
      type: Object,
      default: () => {},
    },
    showEmailEditor: {
      type: Boolean,
      default: false,
    },
    updateChatScrollbar: {
      type: Boolean,
      default: false,
    },
    textFieldSize: {
      type: Number,
      default: 44,
    },
  },
  mixins: [
    chatCenterMixin,
  ],
  components: {
    VuePerfectScrollbar,
    // EditSolveDialog,
    SolvedDialog,
    ChatCenterMessage,
    Viewer,
  },
  data() {
    return {
      activeAudioElement: null,
      show: false,
      messageId: 0,
      chatCategoryId: 0,
    };
  },
  computed: {
    ...mapGetters({
      showState: 'isShow',
    }),
    messages() {
      let messages = [];
      if (Object.keys(this.chat).length) {
        messages = this.chat.chat_center_messages.map((item, i) => {
          if (item && Object.keys(item).length) {
            const message = item;
            const key = 'created_at';
            const currentDate = moment.utc(item[key], 'YYYY-MM-DD HH:mm:ss');
            const previousDateLocal = i && i != 0 ? moment.utc(this.chat.chat_center_messages[i - 1][key]).local().format('YYYY-MM-DD') : null;
            const comparison = currentDate.local().format('YYYY-MM-DD') !== previousDateLocal;
            if (!i || comparison) {
              message.should_show_date = true;
              const year = currentDate.local().format('YYYY');
              let addYear = false;
              if (moment().format('YYYY') !== year) {
                addYear = true;
              }
              message.date_to_show = currentDate.local().format(`DD [de] MMMM${addYear ? ' [del] YYYY' : ''}`);
            } else {
              message.should_show_date = false;
            }
            if (message.type !== 'message' && message.type !== 'media') {
              message.isOpen = true;
            }
            if (message.type === 'media') {
              try {
                // eslint-disable-next-line
                message.text = JSON.parse(message.text);
              } catch (e) {
                // eslint-disable-next-line
              }
            }
            if(this.chat.chat_center_messages[i + 1]) {
              if(this.chat.chat_center_messages[i + 1].type === 'caption') {
                message.caption = this.chat.chat_center_messages[i + 1].text;
              }
            }
            return message;
          }
          return item;
        }).filter((item) => {
          if (item) {
            const message = item;
            return message.type !== 'caption';
          }
        });
      }
      // if (this.chat.channel_id === 7) {
      //   this.buildAudio();
      // }
      return _.orderBy(messages, 'created_at', 'asc');
    },
    css() {
      return {
        '--height': `calc(310px - ${this.textFieldSize}px)`,
        '--max-height': `calc(310px - ${this.textFieldSize}px)`,
      };
    },
  },
  filters: {
    moment(date, to) {
      return moment(date).format(to);
    },
  },
  methods: {
    activeAudio(newVal) {
      if (newVal !== this.activeAudioElement) {
        if (this.activeAudioElement != null) {
          this.activeAudioElement.pause();
          this.activeAudioElement.parentElement.querySelector('.playButton').querySelector('i').className = 'fas fa-play';
        }
        this.activeAudioElement = newVal;
      }
    },
    scrollToMessage(messages) {
      const scrollBar = this.$refs.chatRoomScrollbar.$el;
      const itemsHeight = Array.from(messages)
        .reduce((actual, before) => actual + before.scrollHeight, 0);
      scrollBar.scrollTo(0, scrollBar.scrollHeight - (itemsHeight + (32 * messages.length))); // eslint-disable-line
    },
    solve() {
      if (this.chat.chat_center_status_id !== 7) {
        this.$store.commit('SET_CHAT_CENTER_ID', this.chat.id);
        this.$store.commit('SET_SHOW', true);
      } else {
        // EventBus.$emit('openConfirmDialog', this.chat.id, 'unsolve');
      }
    },
    markSolved(data) {
      this.$emit('mark-solved', data);
    },
    updateChatCategory($event) {
      const index = this.chat.chat_center_messages.findIndex(item => item.id === this.messageId);
      if (index !== -1) {
        this.$set(this.chat.chat_center_messages, index, $event);
      }
    },
    updateChatCategory($event) {
        const index = this.chat.chat_center_messages.findIndex(item => item.id === this.messageId);
        if (index !== -1) {
          this.$set(this.chat.chat_center_messages, index, $event);
        }
      },
    changeChatCategory(id, categoryId) {
      this.show = true;
      this.messageId = id;
      this.chatCategoryId = categoryId;
    },
  },
  watch: {
    chat(newVal, oldVal) {
      if (this.channel_id === 7 && this.activeAudioElement) {
        this.activeAudioElement.pause();
        this.activeAudioElement = null;
      }
      if (newVal.id !== oldVal.id) {
        this.form.text = '';
        this.showEmailEditor = false;
      }
    },
    messages: {
      immediate: true,
      handler() {
        const unreadedElements = document.getElementsByClassName('unreaded');
        this.$nextTick(() => {
          // if (this.chat.channel_id === 7) {
          //   this.buildAudio();
          // }
          this.scrollToMessage(unreadedElements);
        });
      },
    },
    updateChatScrollbar(value) {
      if (value) {
        this.$refs.chatRoomScrollbar.update();
        this.$nextTick(() => {
          const scrollBar = (this.$refs.chatRoomScrollbar.$el || {});
          scrollBar.scrollTop = scrollBar.scrollHeight;
          this.$emit('scrollbarUpdated');
        });
      }
    },
  },
};
</script>

<style scoped>
  .btn.pointy-borders {
    border-radius: 0px;
  }
  .resolve-btn {
    margin-top: 0;
    margin-bottom: 0;
  }
  .chat-room-container > .ps-container {
    height: var(--height);
    min-height: var(--max-height);
    background-color: #eceff1 !important;
  }
  .chat-room-container.email-editor-opened .ps-container {
    height: 145px;
    min-height: 145px;
  }
  .chat-room {
    height: auto;
    background-color: #eceff1 !important;
  }
  .movement-chip {
    background-color: #fff !important;
    border: 1px solid #ff7c64 !important;
  }
  .chat-room .message-chip {
    cursor: pointer;
    border-radius: 28px;
    word-break: break-word;
  }
  .chat-room .message-chip >>> .chip__content {
    cursor: pointer !important;
    display: block;
  }
  .movement-chip.chip--active:not(.chip--disabled),
  .movement-chip.chip--selected:not(.chip--disabled),
  .movement-chip.chip:focus:not(.chip--disabled) {
    border: 1px solid #ff7c64 !important;
  }
  .subName {
    font-size: 12px;
    text-align: left;
    color: #a99a9a;
    font-weight: 500;
  }
  .position-relative {
    position: relative;
  }
  .chat-room .security-message {
    background-color: lightyellow;
    border-color: white;
    max-width: 40ch !important;
    padding: 5px;
    border-radius: 28px;
    width: auto;
    margin: 0 auto;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/chat_center_v2/Chat.vue